import i18n from '../../language/index'
if (process.env.NODE_ENV === 'development') {
  var my_config = require('../../../config/index');
}
import link_data from '@/base/linkData';
import {get_pags} from '@/api/app';
import default_pages from '@/router/default'
import Cookies from "js-cookie";
import {
  getCookie,
} from '@/base/cookie'
//整个系统的变量
const app = {
  namespaced: true,
  state: {
    topBarVisible: true,
    topBarHeight: 72,
    app_isSHow: true,
    pageDataLoading: false,
    widgets_id: 1000000,
    theme_id: '',//全局模板id,
    now_page: 'index', //当前选中的页面
    view_pattern: 'pc',//当前的视图模式
    col_width_change: {
      direction: '',
      normal: 0,
    },
    laybox_paddingBottom: 0,
    module_Data: null,//保存正在编辑的对象,
    moduleSelectItemId: '',
    editPhotoListSelectId: '',
    navListData: null,//导航栏数据
    addModule_col: null,//点击添加模块，记录列，然后把挂件往其中加入
    screenWidth: document.documentElement.clientWidth,
    websiteSection: [], // 网站栏目,全局导航
    logoUrl: '',//网站logo链接
    proList: [], //产品列表
    proTypeList: [], //产品分类列表
    articleList: [], //新闻列表
    articleTypeList: [], //新闻分类列表
    caseList: [], //案例列表
    caseTypeList: [], //案例分类列表
    helpList: [], //帮助列表
    helpTypeList: [], //帮助分类列表
    formList: [], //表单列表
    se_form_id: {}, // 选择的表单ID对象
    linkData: link_data,
    manageFormURL: process.env.BASE_WM_Website_Domain + '/#/zhEnquiry/formList_en',
    pages: [],
    historyIsChange: false, //判断当前页面的历史记录 是否改变
    role: 'customer',//角色
    language: 'zh-cn', // 语言
    material_save_isShow: false,
    submit_form_isShow: false,
    main_dialog_close_IsShow: true,
    form: {},
    basic_banner_isRender: true,
    video_dialog_isShow: false,
    video_data: {},
    basic_list_photos_isRender: true,
    se_item_index: -1,
    form_item_tab: 'add',
    form_item_is_button: false,
    basic_atlas_catalog_isRender: true,
    basic_pro_display_isRender: true,
    basic_development_history_isRender: true,
    basic_article_list_isRender: true,
    is_change: false,
    save_loading: false,
    login_dialog_isShow: false,
    is_operation: false,
    is_add_history: true,
    admin_token: '',
    languageList: {}, // 语言列表
    language_position: 'header', //多语言显示位置
    show_translate: false,
    Fshop:false,
    edit_column: {},//当前正在编辑的列
    footnav_edit: {
      isShow: false,
      left: 0,
      bottom: 0,
      timer: null
    },
    road_type: 0,// 1 为外贸站
    webtitleStyle: 'type_0', //网站标题选择的标题样式
    //is_scale:false,//浏览器是否在缩放状态下
    translate_language: [], //翻译语言，选择的网站
    scrollType: 'normal',
    fullPageCurrentIndex: 0,
    fullPageAniClass: {},
    twoLevelNavList: [], //前两级导航栏栏目列表
    threeLevelNavList: [], //前三级导航栏栏目列表
    isTranslateBanner: 0, // 是否翻译顶部banner，默认不翻译
    is_inline: false, // 是否上线,
    icp_info: '',// icp备案信息
    static_placeholder: i18n.t('vuex_modules_app_297'),
    seo_title_hover: i18n.t('vuex_modules_app_298'),
    seo_keywords_hover: i18n.t('vuex_modules_app_299'),
    seo_description_hover: i18n.t('vuex_modules_app_300'),
    seo_title_tips: i18n.t('vuex_modules_app_301'),
    seo_keywords_tips: i18n.t('vuex_modules_app_302'),
    seo_description_tips: i18n.t('vuex_modules_app_303'),
    thumbnailWidgetsArr: ['basic_article_list','basic_icon_combination','basic_list_photos','basic_picture','basic_picture_text_swiper','basic_product_display','basic_rich_text'],
    thumbnailWidgetsObj: {
    basic_article_list: {
        className: '.news_list_img'
      },
      basic_icon_combination: {
        className: '.icon-wrapper'
      },
      basic_list_photos: {
        className: '.list_img_back'
      },
      basic_picture: {
        className: '.my_picture'
      },
      basic_picture_text_swiper: {
        className: '.icon-wrapper'
      },
      basic_product_display: {
        className: '.list_img'
      },
      basic_rich_text: {
        className: '.tooptipPart'
      },
      cart_role: false,
      isPrivacyPolicyShow: false,
      isTagShow: false
    },
    designType: 1,//设计类型：1:标准设计 2:差异化设计
    web_language_wm:getCookie('web_language_wm') || 'en'
  },
  mutations: {
    SET_isTagShow(state, val) {
      state.isTagShow = val
    },
    set_isPrivacyPolicyShow (state, val) {
      state.isPrivacyPolicyShow = val
    },
    SET_cart_role(state, val) {
      state.cart_role = val
    },
    SET_col_width_direction(state, val) {
      state.col_width_change.direction = val;
    },
    SET_col_width_normal(state, val) {
      state.col_width_change.normal = val;
    },
    SET_module_Data(state, val) {
      state.module_Data = val;
    },
    changeModuleSelectItemId(state, id) {
      state.moduleSelectItemId = id
    },
    changeEditPhotoListSelectId(state, id) {
      state.editPhotoListSelectId = id
    },
    ADD_widgets_id(state, val) {
      state.widgets_id++;
    },
    Change_pattern(state, val) {
      state.view_pattern = val;
      if (val == 'pc') {
        $('html').removeClass('html_style');
      } else {
        $('html').addClass('html_style');
      }
    },
    set_navListData(state, val) {
      state.navListData = val
    },
    set_addModule_col(state, id) {
      state.addModule_col = id;
    },
    set_screenWidth(state, val) {
      state.screenWidth = val;
    },
    set_website_section(state, val) {
      state.websiteSection = val;
    },
    set_logoUrl(state, val) {
      state.logoUrl = val;
    },
    set_pro_list(state, val) {
      state.proList = val;
    },
    set_pro_type_list(state, val) {
      state.proTypeList = val;
    },
    set_article_list(state, val) {
      state.articleList = val;
    },
    set_article_type_list(state, val) {
      state.articleTypeList = val;
    },
    set_case_list(state, val) {
      state.caseList = val;
    },
    set_case_type_list(state, val) {
      state.caseTypeList = val;
    },
    set_help_list(state, val) {
      state.helpList = val;
    },
    set_help_type_list(state, val) {
      state.helpTypeList = val;
    },
    set_form_list(state, val) {
      state.formList = val;
    },
    set_now_page(state, val) {
      state.now_page = val;
    },
    set_app_isSHow(state, val) {
      state.app_isSHow = val;
    },
    set_pages(state, val) {
      state.pages = val;
    },
    historyChange(state, bol) {
      state.historyIsChange = bol;
    },
    set_role(state, val) {
      state.role = val;
      // if (process.env.NODE_ENV === 'development') {
      //   state.role = 'designer';
      // }
    },
    set_language(state, val) {
      state.language = val
    },
    // 设置主语言
    set_language_main(state, val) {
      state.language_main = val
    },
    set_language_position(state, val) {
      state.language_position = val
    },
    set_languageList(state, val) {
      state.languageList = val
    },
    SET_PRODUCT_FSHOP(state, val) {
      console.log(val,"Fshop")
      state.Fshop = val
    },
    set_material_save_isShow(state, val) {
      state.material_save_isShow = val;
    },
    set_submit_form_isShow(state, val) {
      state.submit_form_isShow = val;
    },
    set_main_dialog_close_IsShow(state, val) {
      state.main_dialog_close_IsShow = val;
    },
    set_form(state, val) {
      state.form = val;
    },
    set_basic_banner_isRender(state, val) {
      state.basic_banner_isRender = val;
    },
    set_video_dialog_isShow(state, val) {
      state.video_dialog_isShow = val;
    },
    set_video_data(state, val) {
      state.video_data = val;
    },
    set_basic_list_photos_isRender(state, val) {
      state.basic_list_photos_isRender = val;
    },
    set_se_item_index(state, val) {
      state.se_item_index = val;
    },
    set_form_item_tab(state, val) {
      state.form_item_tab = val;
    },
    set_form_item_is_button(state, val) {
      state.form_item_is_button = val;
    },
    set_basic_atlas_catalog_isRender(state, val) {
      state.basic_atlas_catalog_isRender = val;
    },
    set_basic_pro_display_isRender(state, val) {
      state.basic_pro_display_isRender = val;
    },
    set_basic_development_history_isRender(state, val) {
      state.basic_development_history_isRender = val;
    },
    set_basic_article_list_isRender(state, val) {
      state.basic_article_list_isRender = val;
    },
    SET_is_change(state, val) {
      state.is_change = val;
    },
    SET_save_loading(state, val) {
      state.save_loading = val;
    },
    set_login_dialog_isShow(state, val) {
      state.login_dialog_isShow = val;
    },
    set_operation(state, val) {
      state.is_operation = val;
    },
    set_theme_id(state, val) {
      state.theme_id = val;
    },
    set_is_add_history(state, val) {
      state.is_add_history = val;
    },
    set_show_translate(state, val) {
      state.show_translate = val
    },
    SET_edit_column(state, val) {
      state.edit_column = val;
    },
    Reset_footnav_edit(state) {
      if (state.footnav_edit.timer) {
        clearTimeout(state.footnav_edit.timer);
      }
      state.footnav_edit.isShow = false;
      state.footnav_edit.timer = null;
      state.footnav_edit.left = 0;
      state.footnav_edit.bottom = 0;
    },
    set_road_type(state, val) {
      state.road_type = val
    },
    set_webtitleStyle(state, val) {
      state.webtitleStyle = val
    },
    set_translate_language(state, val) {
      state.translate_language = val
    },
    setFullPageCurrentIndex(state, val) {
      state.fullPageCurrentIndex = val
    },
    setFullPageAniClass(state, val) {
      state.fullPageAniClass = val
    },
    setScrollType(state, val) {
      state.scrollType = val
    },
    set_twoLevelNavList(state, val) {
      state.twoLevelNavList = val
    },
    set_threeLevelNavList(state, val) {
      state.threeLevelNavList = val
    },
    set_isTranslateBanner(state, val) {
      state.isTranslateBanner = val
    },
    set_is_inline(state, val) {
      state.is_inline = val
    },
    set_icp_info(state, val) {
      state.icp_info = val
    },
    set_pageDataLoading(state, val) {
      state.pageDataLoading = val
    },
    setTopBarVisible(state, val) {
      state.topBarVisible = val
    },
    SET_DESIGN_TYPE(state, val) {
      state.designType = val
    },
    SET_web_language_wm(state, val) {
      state.web_language_wm = val
    },
  },
  actions: {
    get_pags({commit}) {
      return new Promise((resolve, reject) => {
        get_pags().then((e) => {
          if (e.code == 200 && e.data && e.data instanceof Array && e.data.length > 0) {
            commit('set_pages', e.data);
            resolve(e.data);
          } else {
            console.log('页面列表返回失败！')
            commit('set_pages', default_pages);
            reject()
          }
        }).catch((err) => {
          commit('set_pages', default_pages);
          reject()
        })
      })
    }

  },
  getters: {
    is_road_type: state => { // 外贸站判断
      return state.road_type === 1
    },
    form_list_link: state => { // 保单管理的路由 外贸站 he外文站 路由变化
      return `${process.env.BASE_WM_Website_Domain}/#/zhEnquiry/formList_en`
    }
  }

};


export default app;



// WEBPACK FOOTER //
// ./src/vuex/modules/app.js